<template>

    <div>
        <page-title :title="$t('inventory.title')"></page-title>

        <div class="flex flex-col sm:flex-row md:mt-0 mb-4 sm:space-x-8 items-end">
            <div class="flex flex-row flex-1 w-full">
                <filter-menu>
                    <!--                    <switch-input :label="$t('articles.sw')" v-model="form.sw"></switch-input>-->
                    <!--                    <switch-input :label="$t('articles.tb')" v-model="form.tb"></switch-input>-->
                    <!--                    <switch-input :label="$t('articles.gx')" v-model="form.gx"></switch-input>-->
                    <!--                    <switch-input :label="$t('articles.protected')" v-model="form.protected"></switch-input>-->
                </filter-menu>

                <search-bar class="flex-1" :placeholder="$t('inventory.search')" v-model="form.search"></search-bar>

                <sort v-model="form.sort" :options="sortOptions"></sort>

            </div>
        </div>
        <pagination class="my-6" :links="movements.links" prefix="t"></pagination>

        <div class="align-middle min-w-full overflow-x-auto shadow overflow-hidden sm:rounded-lg">
            <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                <tr>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('inventory.createdAt') }}
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('inventory.type') }}
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('inventory.diff') }}
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('inventory.currentStock') }}
                    </th>
                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('inventory.sku') }}
                    </th>

                    <th scope="col"
                        class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {{ $t('inventory.name') }}
                    </th>

                </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="entry in movements.data" :key="entry.id">
                    <td class="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        {{ entry.created_at }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        <span
                            :class="entry.color"
                            class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium text-pink-800'">{{ $t(`inventory.${entry.type}`)}}</span>
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ entry.diff }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ entry.current }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ entry.sku }}
                    </td>
                    <td class="px-3 py-4 whitespace-nowrap text-sm text-gray-500">
                        {{ entry.name }}
                    </td>
                </tr>
                </tbody>
            </table>


        </div>

        <pagination class="mt-6" :links="movements.links" prefix="b"></pagination>

    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import PageTitle from "../../Shared/Components/PageTitle";
import {MagnifyingGlassIcon} from "@heroicons/vue/24/outline";
import SearchBar from "../../Shared/Components/SearchBar";
import Pagination from "../../Shared/Components/Pagination";
import {mapValues, pickBy, throttle} from "lodash";
import SwitchInput from "../../Shared/Components/SwitchInput";
import {ref} from "vue";
import Checkbox from "../../Jetstream/Checkbox";
import Sort from "../../Shared/Components/Sort";
import {i18n} from "@/app";
import FilterMenu from "../../Shared/Components/FilterMenu";
import TextLink from "../../Shared/Components/TextLink";

const {t} = i18n.global;

const sortOptions = [
    {id: 'created_at', name: t('inventory.createdAt')},
    {id: 'sku', name: t('inventory.sku')},
    {id: 'diff', name: t('inventory.diff')},
    {id: 'current', name: t('inventory.currentStock')},
]

export default {
    components: {
        TextLink,
        FilterMenu,
        Checkbox,
        Pagination,
        SearchBar,
        PageTitle,
        MagnifyingGlassIcon,
        SwitchInput,
        Sort,
    },
    layout: AppLayout,
    props: ['movements', 'filter', 'sort'],
    setup(props) {
        const form = ref({
            search: props.filter.search,
            sort: props.sort
        })
        return {
            form,
            sortOptions
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                let query = {
                    "filter[search]": this.form.search,
                    "sort": this.form.sort
                };

                this.$inertia.get(this.route("inventory.movements.index"), pickBy(query), {
                    preserveState: true
                });
            }, 700)
        }
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null);
        }
    },

}
</script>

<style scoped>

</style>
